import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import Header from "../Header/Header";
import "../../styles/style.css";
import HeaderFunctions from "../HeaderFunctions/HeaderFunctions";
import Sidebar from "./../Datamigration/sidebar";
import TableComponent from "./TableComponent";

const Loader = () => (
  <div className="spinner-border text-primary" role="status">
    <span className="visually-hidden">Loading...</span>
  </div>
);

const Medisoft = () => {
    const navigate = useNavigate();
    const [Data, setData] = useState([]);
    const [columns, setColumns] = useState([]);
    const [tables, setTables] = useState([]);
    const { loading } = HeaderFunctions();
    const [activeTable, setActiveTable] = useState(null); // Track the clicked <th>
    const [showSearch, setShowSearch] = useState(false);

    useEffect(() => {
        const initiaData = async () => {

            try {
                const response = await axios.get(`http://208.109.243.219:5001/tables?schema=Medisoft`, null,{
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                  }
                });
                setTables(response.data.tables)
              } catch (error) {
                console.error('Error fetching Tables data for View:', error);
              }
        };
    
        initiaData();
      }, []);

      const handleView = async (tableName) => {
        setActiveTable(tableName); // Set the clicked <th> as active
        try {
            const response = await axios.get(`http://208.109.243.219:5001/data?schema=Medisoft&table=${tableName}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });
            setData(response.data.data);
            setColumns(response.data.columns);
        } catch (error) {
            console.error("Error fetching table data:", error);
        }
    };

    // const formatColumn = (header) => {
    //     return header
    //         .split("_") // Split by underscore
    //         .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter
    //         .join(" "); // Join with space
    // };

    const formatColumn = (header) => {
        return header.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
    };
      
    return (
        <>
        <Header loading={loading} />
        <div className="container">
            <nav style={{ "--bs-breadcrumb-divider": ">" }} aria-label="breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item">
                <Link to="#"></Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page"></li>
            </ol>
            </nav>
        </div>

        <div className="container pb-4">
            <div className="box-bdr-dash">
                <div className="row">
                    <Sidebar/>
                    <div className="col-md-10">
                        <div className="box mb-2 form-box">
                            <div className="box-top-title fhir-title">
                            <span className="pd-overview-count">Medisoft Data</span>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="col-md-2" style={{"float":"left"}}>&nbsp;</div>
                                    <div className="col-md-3" style={{"float":"left"}}>
                                        <select className="form-select undefined">
                                            <option>Select Project</option>
                                        </select>
                                    </div>
                                    <div className="col-md-1" style={{"float":"left"}}>&nbsp;&nbsp;</div>
                                    <div className="col-md-3" style={{"float":"left"}}>
                                        <select  className="form-select undefined">
                                            <option>Select Customer</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <button
                                        type="button"
                                        className="btn btn-primary cancel-btn"
                                        onClick={() => setShowSearch((prev) => !prev)}
                                    >
                                        Patient Chart
                                    </button>
                                    <div className="table-data-box table-responsive ">
                                        <table className="table-content borderd-table" >
                                            <thead>
                                                {tables.length > 0 && tables.map((item, index) => (
                                                    <tr className={"active-link"} key={index}>
                                                        <th onClick={() => handleView(item)} className={activeTable === item ? "active-th" : "link"}
                                                                    style={{ cursor: "pointer" }}> {formatColumn(item)}</th>
                                                        
                                                    </tr>
                                                ))}
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div className="col-md-9">
                                    <TableComponent Data={Data} columns={columns} showSearch={showSearch} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};
export default Medisoft;